import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { DiagnosticsFormGroupService } from '../diagnostics-form-group.service';

@Component({
  selector: 'app-diagnostics-default-template',
  templateUrl: './diagnostics-default-template.component.html',
  styleUrls: ['./diagnostics-default-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticsDefaultTemplateComponent {
  @Input() vddName: string;
  @Input() logicalLink: string;
  @Input() saveValue: Subject<void>;
  @Input() diagnosticsFormGroupService: DiagnosticsFormGroupService;
  @Input() parameterId: number;
  @Input() isVddEditable: boolean;

  constructor() {}
}
